import React from 'react'
import { fileEntries } from 'shared/utils/fileType'
import { Text } from '.'
import { FileTypeIcon } from './FileTypeIcon'

/**
 * The files of a media field as lines of "file icon + file name" — the icon is the file's type (PDF, Word, spreadsheet…) in its
 * color, the name is cut with an ellipsis when it does not fit. For a board card or a table cell (field type `file`); draws
 * nothing when the value holds no file.
 */
function FileNameList({ value }) {
  const files = fileEntries(value)
  if (files.length === 0) return null

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
      {files.map((file, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
          <FileTypeIcon name={file.name} url={file.url} style={{ fontSize: 18 }} />
          <Text variant="body2" title={file.name} textCustomProps={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {file.name}
          </Text>
        </div>
      ))}
    </div>
  )
}

export default FileNameList
